import { useBoundContext } from "lib/@components/binding/use-bound-context"
import { AmendsButton } from "./amends-button"

export function AmendsBoundaryButton({ amendsKey }) {
    const { amendsContext } = useBoundContext()
    if (!amendsContext) {
        throw new Error("AmendsBoundaryButton requires amendsContext")
    }

    const state = amendsContext.getAmendsState(amendsKey)

    if (state.isOpen) return null

    return <AmendsButton onClick={open} disabled={!state.canOpen} />

    function open() {
        amendsContext.onOpenAmends(amendsKey)
    }
}
